
import React, { Fragment, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardActions, CardContent, Chip, Divider, Grid, IconButton, List, ListItem, ListItemText, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import { LayoutDashboard } from '../layouts/DasboardLayout';
import { useAuthentication } from '../hooks/useAuthentication';
import { API_URL } from '../config';
import { useFormik } from 'formik';
import toast from 'react-hot-toast';
import MensajeDialog from '../components/Dialogs/MensajeDialog';
import * as Yup from 'yup';
import ScrollbarContainer from '../components/ScrollBar/CustomScrollbar';
import ReplayIcon from '@mui/icons-material/Replay';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';

const initialValues = {
  notaMedica: '',
  indicaciones: '',
  doctor: '',
};

const validationSchema = Yup.object().shape({
  notaMedica: Yup.string(),
  indicaciones: Yup.string(),
  doctor: Yup.string(),
});

const Page = () => {
  const { idUser, especialidad } = useAuthentication();
  const isXs = window.innerWidth < 600;
  const [formSend, setFormSend] = useState(false);
  const [dataResponse, setDataResponse] = useState(null);
  const [registroEcontrado, setRegistroEncontrado] = useState(false);
  const [startWithForm, setStartWithForm] = useState(false);
  const [dataPaciente, setDataPaciente] = useState(null);
  const [registros, setRegistros] = useState([]);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      values.user = idUser;
      const newData = {
        id: dataResponse._id,
        estatus: 'Finalizado',
        data: {
          notaMedica: values.notaMedica,
          indicaciones: values.indicaciones,
          doctor: values.user,
        },
      };
      try {
        const response = await fetch(`${API_URL}/person/consulta/update`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify(newData),
          }
        );
        if (!response.ok) {
          const errorData = await response.json();
          toast.error(errorData.message);
          return;
        }
        const data = await response.json();
        toast.success('Registro guardado correctamente');
        setDataPaciente(data.Data);
        setFormSend(true);

      } catch (error) {
        console.error(error);
        toast.error('Error al guardar el registro');
      }
    }
  });

  const getByFolio = async (folio) => {
    try {
      const response = await fetch(`${API_URL}/person/consulta/${folio}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        const errorData = await response.json();
        toast.error(errorData.message);
        return;
      }
      formik.setValues(data);
      setRegistroEncontrado(true);
      setDataResponse(data);
    } catch (error) {
      console.error(error);
      toast.error('Error al buscar el registro');
    }
  }

  const handleStartWithForm = async () => {
    try {
      const response = await fetch(`${API_URL}/person/consulta/update`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify({
            id: dataResponse._id,
            estatus: 'En Proceso Consulta'
          }),
        }
      );
      //const data = await response.json();
      if (!response.ok) {
        const errorData = await response.json();
        toast.error(errorData.message);
        return;
      }
      toast.success('Registro actualizado correctamente');
      setStartWithForm(true);
    } catch (error) {
      console.error(error);
      toast.error('Error al buscar el registro');
    }
  }

  const getRegistros = async () => {
    try {
      const response = await fetch(`${API_URL}/person/consulta/especialidad/estatus`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify({
            idEspecialidad: especialidad,
            estatus: 'Finalizado Triage'
          }),
        }
      );
      const data = await response.json();
      if (!response.ok) {
        const errorData = await response.json();
        toast.error(errorData.message);
        return;
      }
      setRegistros(data.Data);
    } catch (error) {
      console.error(error);
    }
  }

  const handleDelete = async (data, type) => {
    const espe = type === 'icon' ? data.id : data?.consultas[0]?.especialidad;
    try {
      const response = await fetch(`${API_URL}/person/consulta/update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          id: data._id,
          estatus: 'Descartado Consulta',
          data: {
            especialidad: espe,
          }
        }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        toast.error(errorData.message);
        return;
      }
      toast.success('Registro eliminado correctamente');
      //Recargar pagina despues de dos segundos
      setTimeout(() => {
        window.location.reload();
      }, 2000);

    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getRegistros();
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        p: 5,
      }}
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={12}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: isXs ? 'column' : 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '100%',
              width: '100%',
            }}
          >
            <Typography
              variant="h4"
              align="center"
              color="textPrimary"
              gutterBottom
              fontWeight={700}
            >
              Médico
            </Typography>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <TextField
                required
                label="Turno"
                name="turno"
                value={formik.values.turno}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.turno && Boolean(formik.errors.turno)}
                helperText={formik.touched.turno && formik.errors.turno}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  width: '100%',
                  maxWidth: '300px',
                  backgroundColor: 'white',
                }}
              />
              <Button
                color="primary"
                variant="contained"
                sx={{
                  marginLeft: 2,
                }}
                onClick={() => getByFolio(formik.values.turno)}
              >
                Buscar
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
        >
          <Card
            sx={{
              width: '100%',
              borderRadius: 5,
            }}
          >
            <ScrollbarContainer>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                  height: '100%',
                  pl: 2,
                }}
              >
                <Typography
                  variant="h6"
                  color="primary.gold"
                >
                  Registros
                </Typography>
                <Tooltip title="Recargar tabla">
                  <IconButton
                    sx={{
                      marginRight: 2,
                    }}
                  >
                    <ReplayIcon color='primary' />
                  </IconButton>
                </Tooltip>
              </Box>
              <Table>
                <TableHead>
                  <TableCell>
                    Folio
                  </TableCell>
                  <TableCell>
                    Nombre
                  </TableCell>
                  <TableCell>
                    Fecha de creación
                  </TableCell>
                  <TableCell align="center">
                    Estatus
                  </TableCell>
                  <TableCell align="right">
                    Acciones
                  </TableCell>
                </TableHead>
                <TableBody>
                  {registros?.map((especialidad, index) => (
                    <Fragment key={especialidad.folio}>
                      <TableRow
                        hover
                        key={especialidad.folio}
                      >
                        <TableCell>
                          <Typography
                            variant="body2"
                            color="primary.textDark"
                          >
                            {especialidad?.folio}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            color="primary.textDark"
                          >
                            {especialidad?.nombre}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body2"
                            color="primary.textDark"
                          >
                            {new Date(especialidad?.updatedAt).toLocaleDateString()}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={index === 0 ? 'Siguiente' : 'En espera'}
                            color={index === 0 ? 'success' : 'default'}
                          />
                        </TableCell>
                        <TableCell align="right">
                          <Box>
                            <Tooltip title="Eliminar registro">
                              <IconButton
                                sx={{
                                  color: 'primary.dark',
                                }}
                                onClick={() => handleDelete(especialidad, 'icon')}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Atender paciente">
                              <Button
                                color="primary"
                                variant="contained"
                                onClick={() => getByFolio(especialidad.folio)}
                              >
                                Atender
                              </Button>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </Fragment>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[40, 80, 120]}
                component='div'
                count={registros?.length}
                rowsPerPage={10}
                page={0}
                onPageChange={() => { }}
                onRowsPerPageChange={() => { }}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                labelRowsPerPage='Filas por página'
              />
            </ScrollbarContainer>
          </Card>
        </Grid>

        {dataResponse && (
          <Grid
            item
            xs={12}
            md={dataResponse ? 4 : 12}
          >
            <Accordion
              defaultExpanded
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography
                  component="span"
                  variant="subtitle1"
                  color="primary"
                  fontWeight={700}
                >
                  Datos del paciente
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <List>
                  <ListItem>
                    <ListItemText
                      primary={'Folio'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.folio}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Nombre'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.nombre}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Dirección'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.direccion}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Teléfono'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.telefono}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Fecha de nacimiento'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={new Date(dataResponse?.fechaNacimiento).toLocaleDateString()}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Edad'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.edad}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'CURP'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.curp}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Municipio'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.municipio}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Sexo'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.sexo}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Estatus'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.estatus}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Fecha de creación'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={new Date(dataResponse?.updatedAt).toLocaleDateString()}
                    />
                  </ListItem>
                </List>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography
                  component="span"
                  variant="subtitle1"
                  color="primary"
                  fontWeight={700}
                >
                  Expediente
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  padding: 0,
                }}
              >
                <List
                  sx={{
                    width: '100%',
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <ListItem>
                    <ListItemText
                      primary={'Peso'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].peso}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Talla'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].talla}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Frecuencia Cardiaca'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].frecuenciaCardiaca}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Frecuencia Respiratoria'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].frecuenciaRespiratoria}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Presión Arterial'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={`${dataResponse?.consultas[0].presionArterialUno}/${dataResponse?.consultas[0].presionArterialDos}`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Temperatura'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].temperatura}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Saturación de CO2'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].saturacionCo2}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Perímetro Abdominal'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].perimetroAbdominal}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Glucosa'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].glucosa}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Motivo de consulta'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].motivo}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Fecha de creación'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={new Date(dataResponse?.updatedAt).toLocaleDateString()}
                    />
                  </ListItem>
                </List>
              </AccordionDetails>
            </Accordion>
          </Grid>
        )}

        {registroEcontrado && (
          <Grid
            item
            xs={12}
            md={dataResponse ? 8 : 12}
          >
            <Card
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                flexDirection: 'column',
                borderRadius: '20px',
                padding: 2,
              }}
            >
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      color="textPrimary"
                    >
                      Nombre del paciente:  {" "} <strong>{dataResponse.nombre}</strong>
                    </Typography>
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                      width: '100%',
                    }}
                  >
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={() => handleDelete(dataResponse, 'button')}
                      sx={{
                        marginRight: 2,
                      }}
                    >
                      Eliminar registro
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={handleStartWithForm}
                    >
                      Comenzar registro
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Card>
            {startWithForm && (
              <Card
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  flexDirection: 'column',
                  borderRadius: '20px',
                  marginTop: 5,
                }}
              >
                <CardContent
                  sx={{
                    width: '100%',
                  }}
                >

                  <ScrollbarContainer>
                    <Typography
                      variant="h5"
                      align="center"
                      color="textPrimary"
                      gutterBottom
                      fontWeight={700}
                    >
                      Formulario de Registro
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      color="textPrimary"
                      gutterBottom
                    >
                      Formulario Médico para atención al paciente
                    </Typography>
                    <Divider sx={{ mt: 2, mb: 2 }} />
                    <Grid
                      container
                      spacing={2}
                    >
                      <Grid
                        item
                        xs={12}
                        md={12}
                      >
                        <TextField
                          required
                          multiline
                          rows={4}
                          label="Nota Médica"
                          name="notaMedica"
                          value={formik.values.notaMedica}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.notaMedica && Boolean(formik.errors.notaMedica)}
                          helperText={formik.touched.notaMedica && formik.errors.notaMedica}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                      >
                        <TextField
                          required
                          multiline
                          rows={4}
                          label="Indicaciones"
                          name="indicaciones"
                          value={formik.values.indicaciones}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.indicaciones && Boolean(formik.errors.indicaciones)}
                          helperText={formik.touched.indicaciones && formik.errors.indicaciones}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                    </Grid>
                  </ScrollbarContainer>
                </CardContent>
                <CardActions
                  sx={{
                    display: 'flex',
                    justifyContent: 'right',
                    width: '100%',
                    padding: 2,
                  }}
                >
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={formik.resetForm}
                  >
                    Limpiar
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={formik.handleSubmit}
                  >
                    Guardar
                  </Button>
                </CardActions>
              </Card>
            )}
          </Grid>
        )}

      </Grid>
      <MensajeDialog
        open={formSend}
        data={dataPaciente}
        handleClose={() => setFormSend(false)}
      />
    </Box >
  );
};

const Medico = () => {
  return (
    <LayoutDashboard>
      <Page />
    </LayoutDashboard>
  );
}

export default Medico;
